<template>
    <span class="f-staff-show">
        <span :class="{'has-padding': hasPaddingStyle}">
            <!-- 是否展示用户头像 -->
            <span v-if="Object.keys(userInfo).length">
                <img v-if="!loading"
                    :src="userInfo.avatar"
                    class="f-staff-show-avatar">
            </span>
            <!-- 是否展示头像loading态 -->
            <span v-if="loading" class="f-staff-show-loading-avatar">
                <veui-icon name="undo"></veui-icon>
            </span>

            <!-- 是否展示用户昵称 -->
            <span v-if="!loading" class="f-staff-show-nickname">
                {{userName}}
            </span>
            <!-- 是否展示昵称loading态 -->
            <span v-else class="f-staff-show-nickname">
                loading...
            </span>
        </span>

        <veui-button ui="primary"
            v-if="!isClosed && canOperateOfficial"
            :disabled="isAuditPending"
            class="f-staff-show-btn"
            @click="toggle">分配给他人</veui-button>

        <veui-button ui="primary"
            v-if="!officialinfo.icafeUrl && type !== 'officialaudit'"
            :disabled="isAuditPending"
            class="f-staff-show-btn"
            @click="establish">创建iCafe(技术支持空间)</veui-button>

        <veui-button ui="primary"
            v-if="officialinfo.icafeUrl && type !== 'officialaudit'"
            v-show="isClosed && !isIcafeSynced"
            class="f-staff-show-btn"
            @click="synchronize">信息同步至iCafe卡片</veui-button>
        <!-- 人员列表弹窗 -->
        <staff-box
            v-if="isShowStaff"
            :confirm="isShowStaff"
            :listtype="type"
            :selected="selectedStaff"
            @ok="confirmSelectedStaff"
            @cancel="toggle">
        </staff-box>
    </span>
</template>

<style lang="less">
    @import '../../../../assets/less/views/topic-content/official-process/staff-assign.less';
</style>

<script>

import {Button, Icon} from 'veui';
import 'veui-theme-one-icons';
import {mapState, mapGetters} from 'vuex';
import {notAllowScroll, allowScroll, scrollToId} from '@/utils/decorate/scroll';
import StaffBox from '@/views/components/FollowUserBox.vue';

export default {
    props: {
        type: {
            'type': String,
            'default': 'officialsupporter'
        }
    },
    data() {
        return {
            isShowStaff: false,
            loading: false,
            // 防止按钮多次点击 默认为可点击
            showIcode: false,
            showSyncBtn: false
        };
    },
    components: {
        'veui-button': Button,
        'veui-icon': Icon,
        'staff-box': StaffBox
    },
    computed: {
        ...mapState({
            officialinfo: state => state.topicContent.topicData.ext.qaOfficialInfo
        }),
        ...mapGetters([
            'followUserName',
            'auditUserName',
            'canOperateOfficial',
            'isClosed',
            'isAuditPending',
            'isIcafeSynced'
        ]),
        userInfo: {
            get() {
                return this.type === 'officialaudit'
                    ? this.officialinfo.auditUserInfo
                    : this.officialinfo.followUserInfo;
            }
        },
        userName: {
            get() {
                return this.type === 'officialaudit'
                    ? this.auditUserName
                    : this.followUserName;
            }
        },
        hasPaddingStyle() {
            return this.type === 'officialaudit'
                    && (!this.canOperateOfficial
                        || this.isClosed);
        },
        selectedStaff: {
            get() {
                return this.userInfo.id;
            }
        }
    },
    methods: {
        confirmSelectedStaff(followUserInfo) {
            this.loading = true;
            if (this.type === 'officialaudit') {
                this.$store.dispatch('changeOfficialAudit', followUserInfo)
                    .then(() => {
                        scrollToId('official-audit');
                        this.loading = false;
                    });
                return;
            }
            this.$store.dispatch('changeOfficialFollower', followUserInfo)
                .then(() => {
                    scrollToId('official-board');
                    this.loading = false;
                });
        },
        toggle() {
            this.isShowStaff = !this.isShowStaff;
            if (this.isShowStaff) {
                notAllowScroll();
            }
            else {
                allowScroll();
            }
        },
        establish() {
            if (!this.showIcode) {
                this.$store.dispatch('establishList');
                this.showIcode = true;
            }
            // 防止按钮多次点击，测试发现1000ms 偶尔会出现防止不住的情况，所以设置为1500ms
            setTimeout(() => {
                this.showIcode = false;
            }, 1500);
        },
        synchronize() {
            if (!this.showSyncBtn) {
                this.$store.dispatch('syncIcafeInfo');
                this.showSyncBtn = true;
            }
            // 防止按钮多次点击
            setTimeout(() => {
                this.showSyncBtn = false;
            }, 1500);
        }
    }
};
</script>
